/// <reference path="../../Common/Base/SiteEntityDialog.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    @Serenity.Decorators.panel()
    export class CountryDialog extends SiteEntityDialog<CountryRow, any> {
        protected getFormKey() { return CountryForm.formKey; }
        protected getIdProperty() { return CountryRow.idProperty; }
        protected getLocalTextPrefix() { return CountryRow.localTextPrefix; }
        protected getNameProperty() { return CountryRow.nameProperty; }
        protected getService() { return CountryService.baseUrl; }

        protected form = new CountryForm(this.idPrefix);

    }
}